import React from 'react';
import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';
import { ListPlus } from 'phosphor-react';

export interface EmptyStateAction {
  label: string;
  onClick: () => void;
}

export interface EmptyStateProps {
  title: string;
  description: string;
  action?: EmptyStateAction;
  testId?: string;
}

export function EmptyState({
  title,
  description,
  action,
  testId = 'empty-state',
}: EmptyStateProps) {
  return (
    <VStack
      data-testid={testId}
      role="status"
      aria-label={`${title}. ${description}`}
      spacing={4}
      px={6}
      py={12}
      textAlign="center"
      borderRadius="lg"
      background="white"
      width="100%"
    >
      <Box color="gray.400" aria-hidden="true">
        <ListPlus size={72} />
      </Box>
      <Heading as="h2" size="md" color="gray.700">
        {title}
      </Heading>
      <Text color="gray.600" maxWidth="520px">
        {description}
      </Text>
      {action && (
        <Button colorScheme="blue" onClick={action.onClick} aria-label={action.label}>
          {action.label}
        </Button>
      )}
    </VStack>
  );
}
